//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
/*
 * ----------------
 * Core selectors
 * ----------------
 */
export var getMinWidth = function (theme) {
    return theme.v1.core.minWidth;
};
export var getMaxWidth = function (theme) {
    return theme.v1.core.maxWidth;
};
export var getBorderRadius = function (theme) {
    return theme.v1.core.borderRadius;
};
export var getBorderWidth = function (theme) {
    return theme.v1.core.borderWidth;
};
export var getGridUnit = function (theme) {
    return theme.v1.core.gridUnit;
};
export var getTransition = function (theme) {
    return theme.v1.core.transition;
};
/*
 * ----------------
 * Icons selectors
 * ----------------
 */
export var getIconsUrl = function (theme) {
    return theme.v1.icons.iconUrl;
};
export var getIconsAllSizes = function (theme) {
    return theme.v1.icons.sizes;
};
export var getIconsSizesSmall = function (theme) {
    return theme.v1.icons.sizes.small;
};
export var getIconsSizesMedium = function (theme) {
    return theme.v1.icons.sizes.medium;
};
export var getIconsSizesLarge = function (theme) {
    return theme.v1.icons.sizes.large;
};
export var getIconsSizesxLarge = function (theme) {
    return theme.v1.icons.sizes['x-large'];
};
export var getIconsAllGlyphs = function (theme) {
    return theme.v1.icons.glyphs;
};
/*
 * ----------------
 * Form fields selectors
 * ----------------
 */
export var getFormFieldsInputHeight = function (theme) {
    return theme.v1.formFields.input.height;
};
export var getFormFieldsCheckboxHeight = function (theme) {
    return theme.v1.formFields.checkbox.height;
};
export var getFormFieldsSwitchHeight = function (theme) {
    return theme.v1.formFields.switch.height;
};
/*
 * ----------------
 * Legacy selectors
 * ----------------
 *
 * Use the current theme when migration is complete
 * During migration use the theme we're migrating from
 */
export var getLegacyMinWidth = function (theme) {
    return theme.sparkplug.core.minWidth;
};
export var getLegacyMaxWidth = function (theme) {
    return theme.sparkplug.core.maxWidth;
};
export var getLegacyBorderRadius = function (theme) {
    return theme.sparkplug.core.borderRadius;
};
export var getLegacyBorderWidth = function (theme) {
    return theme.sparkplug.core.borderWidth;
};
export var getLegacyGridUnit = function (theme) {
    return theme.sparkplug.core.gridUnit;
};
export var getLegacyTransition = function (theme) {
    return theme.sparkplug.core.transition;
};
